/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import SecureIcon from 'DesignSystem/Svgs/SecureIcon/index'
import StatusTooltip from './StatusTooltip/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/InApp/Content/Outbound/Secure/Content",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<SecureIcon
  viewPath={`${viewPath}/SecureIcon`}
 height={16}
 width={16}
/>
<StatusTooltip
  viewPath={`${viewPath}/StatusTooltip`}
 flowNo={!isHovered}
 flowContent={isHovered}
/>
</button>
{children}
</React.Fragment>)
}